import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-iackathon-intro-page',
    imports: [
        RouterLink
    ],
  templateUrl: './iackathon-intro-page.component.html',
  styleUrl: './iackathon-intro-page.component.scss',
})
export class IackathonIntroPageComponent {

}
